/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../helpers'
import {useGetUser} from '../../../../app/tfi/store/userStore'
import {prependBackendUrl} from '../../../../app/tfi/gql/client'
import {useUserPreferencesStore} from '../../../../app/tfi/store/userPreferencesStore'
import {useSyncPreferences} from '../../../../app/tfi/hooks/useSyncPreferences'

const HeaderUserMenu: FC = () => {
  const logout = useGetUser((s) => s.logout)
  const user = useGetUser((s) => s.user)
  const sidebarView = useUserPreferencesStore((s) => s.sidebarView)
  const setSidebarView = useUserPreferencesStore((s) => s.setSidebarView)
  useSyncPreferences()

  if (!user) return null
  const email = user.payload?.email || user.user?.email || ''
  const fullName = [user.user?.firstName, user.user?.lastName].filter(Boolean).join(' ') || email.split('@')[0] || 'User'

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img
              alt='Logo'
              src={
                user.user?.avatar
                  ? prependBackendUrl(user.user.avatar)
                  : toAbsoluteUrl('/media/tfi/logo-icoN.png')
              }
              style={{objectFit: 'cover', borderRadius: '50%'}}
            />
          </div>

          <div className='d-flex flex-column flex-grow-1 min-w-0'>
            <div className='fw-bolder d-flex align-items-center fs-5 flex-wrap gap-2'>
              {fullName}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1'>Pro</span>
            </div>
            <a
              href='#'
              className='fw-bold text-muted text-hover-primary fs-7'
              style={{overflowWrap: 'anywhere', wordBreak: 'break-word'}}
              title={email}
            >
              {email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='separator my-2'></div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div> */}

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <div className='menu-content px-3 py-2'>
          <div className='d-flex align-items-center justify-content-between'>
            <span className='text-muted fs-7 fw-semibold'>Interface</span>
            <label className='form-check form-switch form-check-custom form-check-solid mb-0'>
              <input
                className='form-check-input w-35px h-20px'
                type='checkbox'
                checked={sidebarView === 'legacy'}
                onChange={(e) => setSidebarView(e.target.checked ? 'legacy' : 'new')}
              />
              <span className='form-check-label text-muted fs-8 ms-2'>Legacy</span>
            </label>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <button
          onClick={logout}
          style={{backgroundColor: 'transparent', border: 0}}
          className='w-100 menu-link px-5 d-flex align-items-center gap-2'
        >
          <i className='bi bi-box-arrow-in-left fs-2' style={{color: 'inherit'}} />
          Sign Out
        </button>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
